import React from "react";
import { ContentProps } from "../types";
import { Box } from "@mui/material";

export function Content({ 
    children, 
    className,
    maxHeight = 400 
}: ContentProps) {
    return (
        <Box 
            className={className}
            sx={{
                maxHeight: typeof maxHeight === "number" ? `${maxHeight}px` : maxHeight,
                overflowY: "auto",
                overflowX: "hidden",
            }}
        >
            {children}
        </Box>
    );
}

export default Content;
